$(document).ready(function () {
	function clearEmailSuggestion(el) {
		$(el).find('a').off('click');
		$(el).html('');
	}

	$('[data-mailcheck]').on('blur', function () {
		var suggestionEl = $('#' + $(this).data('mailcheck-suggestion-id')),
			inputEl = $(this);
			
		$(this).mailcheck({
			suggested: function (element, suggestion) {
				suggestionEl.html('Did you mean <a href="#">' + suggestion.full + '</a>?');

				suggestionEl.find('a').on('click', function (e) {
					e.preventDefault();

					inputEl.val($(this).text());

					clearEmailSuggestion(suggestionEl);

					return false;
				});
			},
			empty: function (element) {
				clearEmailSuggestion(suggestionEl);
			}
		});
	});
});